module.exports = __webpack_public_path__ + "assets/img/index-partner10.1ac41908.jpg";